import { IVariation } from "@/interfaces/sku.interface";
import {
  createEmptyVariation,
  mergeProductAndSkuVariations,
  parseVariationsFromString,
  stringifyVariations,
} from "@/helpers/variation-helpers";

export const getSkuVariationsFromString = (variationsString: string): IVariation[] => {
  return parseVariationsFromString(variationsString);
};

export const mergeVariationsForEditing = (
  productVariations: any[],
  skuVariationsString: string
): IVariation[] => {
  const skuVariations = getSkuVariationsFromString(skuVariationsString);
  return mergeProductAndSkuVariations(productVariations, skuVariations);
};

export const initializeEmptyVariationsForNewSku = (
  variationCodes: string[],
  fetchedVariations: Array<{ id: number; description: string }>
): IVariation[] => {
  return variationCodes.map((code) => {
    const variationItem = fetchedVariations.find((item) => item.id === Number(code));
    return createEmptyVariation(Number(code), variationItem?.description || "");
  });
};

export const updateVariationValue = (
  variations: IVariation[],
  code: number,
  name: string,
  value: string
): IVariation[] => {
  const updatedVariations = [...variations];
  const index = updatedVariations.findIndex((v) => v.VariationCode === code);

  if (index !== -1) {
    updatedVariations[index].VariationValue = value;
  } else {
    updatedVariations.push(createEmptyVariation(code, name));
    updatedVariations[updatedVariations.length - 1].VariationValue = value;
  }

  return updatedVariations;
};

export const getVariationValue = (variations: IVariation[], code: number): string => {
  return variations.find((v) => v.VariationCode === code)?.VariationValue || "";
};

export const serializeVariations = (variations: IVariation[]): string => {
  return stringifyVariations(variations);
};
